var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrandLogoBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 85,
    viewBox: "0 0 99 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.9734 84.2427L43.7082 43.4248L61.2978 14.1088L98.7025 84.2427H65.9734ZM28.5687 32.8112L56.6222 84.2427H0.515137L28.5687 32.8112ZM16.8797 23.46C13.7796 23.46 10.8065 22.2285 8.61435 20.0364C6.42224 17.8443 5.19073 14.8711 5.19073 11.771C5.19073 8.6709 6.42224 5.69776 8.61435 3.50565C10.8065 1.31354 13.7796 0.0820313 16.8797 0.0820312C19.9798 0.0820312 22.9529 1.31354 25.1451 3.50565C27.3372 5.69776 28.5687 8.6709 28.5687 11.771C28.5687 14.8711 27.3372 17.8443 25.1451 20.0364C22.9529 22.2285 19.9798 23.46 16.8797 23.46Z",
    fill: "#212529"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandLogoBlack);
export default __webpack_public_path__ + "static/media/brand-logo-black.252a6a191f0a297dcaebc444df8b732e.svg";
export { ForwardRef as ReactComponent };